import { NOT_STARTED } from '@/lib/constants/actionStatuses'

const buildInitialState = (data) => ({
  ...data,
  meta: {
    status: NOT_STARTED,
    error: null
  }
})

export default buildInitialState
